import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6321cb1e")

_pushScopeId("data-v-6321cb1e")
const _hoisted_1 = {
  class: "toc_ui__remarks_main",
  id: "RemarksInfo"
}
const _hoisted_2 = { class: "toc_ui__remarks_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__remarks_title" }, "检测师信息", -1)
const _hoisted_4 = { class: "toc_ui__remarks_cnt" }
const _hoisted_5 = { class: "flex-box" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex-label" }, "检测师姓名", -1)
const _hoisted_7 = { class: "flex-value" }
const _hoisted_8 = { class: "flex-box" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "flex-label" }, "报告出具日期", -1)
const _hoisted_10 = { class: "flex-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.state.name), 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("div", _hoisted_10, _toDisplayString(_ctx.state.date), 1)
        ])
      ])
    ])
  ]))
})